export default "__VITE_ASSET__CIwo_uAn__"